module.exports = __webpack_public_path__ + "static/media/elements_list.4386bce6.png";